export default "__VITE_ASSET__CdDUV$23__"